import React, { Component, Fragment } from 'react';
import withTranslations from '../../translations';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Prompt } from 'react-router-dom';
import { isDesktop } from 'react-device-detect';

import { permissions } from '../../constants/permissions';
import { roles } from '../../constants/roles';

import {
  headerHeight,
  subHeaderHeight,
} from '../../constants/styles';

import {
  userHasPermission,
} from '../../utils/permissions';

import {
  userHasRole,
} from '../../utils/roles';

import {
  getSingleJob,
  clearJob,
  downloadAllPictures,
  getSingleJobByNotificationNumber,
} from '../../actions/singleJob';

import { getNumberOfUnreadComments } from '../../actions/conversation';

import {
  Chip,
  ConfirmationDialog,
  DialogContentText,
  ExpansionPanel,
  ExpansionPanelDetails,
  FormControl,
  FormControlLabel,
  Loader,
  Radio,
  RadioGroup,
  Typography,
} from '../../components/base';

import SubHeader from '../../components/SubHeader/SubHeader';
import JobSummary from '../../components/JobSummary/JobSummary';
import JobSection from '../../components/JobSection/JobSection';
import LogSection from '../../components/LogSection/LogSection';
import ConversationSection from '../../components/ConversationSection/ConversationSection';

import ReportsDialog from '../../components/ReportsDialog/ReportsDialog';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import BlockIcon from '@material-ui/icons/Block';

import {
  camelCaseToDash,
} from '../../utils/utils';

import {
  sections,
} from './constants';

const styles = theme => ({
  expansionPanel: {
    width: `calc(100% - ${theme.spacing(2)}px)`,
    margin: `${theme.spacing(4)}px auto`,

    '&.Mui-expanded': {
      margin: `${theme.spacing(4)}px auto`,
    },

    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.spacing(8)}px)`,
    },
  },
  expansionPanelExpanded: {
    '&.Mui-expanded': {
      marginTop: theme.spacing(4),

      '&:first-child': {
        marginTop: theme.spacing(4),
      },

      '&:last-child': {
        marginBottom: theme.spacing(4) ,
      },
    },
  },
  title: {
    fontSize: 22,
  },
  expansionPanelDetails: {
    padding: `${theme.spacing()}px 0 ${theme.spacing(3)}px`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    height: 300,
  },
  noTechPossibilityContainer: {
    margin: `${headerHeight + subHeaderHeight + theme.spacing(6)}px ${theme.spacing()}px ${theme.spacing()}px`,
    padding: theme.spacing(2),
    position: 'relative',
    border: `2px solid ${theme.palette.error.light}`,
    background: 'rgba(229, 115, 115, 0.15)',

    [theme.breakpoints.up('sm')]: {
      margin: `${headerHeight + subHeaderHeight + theme.spacing(6)}px ${theme.spacing(4)}px ${theme.spacing(4)}px`,
      padding: `${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
  },
  numOfUnreadComments: {
    position: 'absolute',
    right: theme.spacing(7),
    color: theme.palette.primary,
    fontWeight: 'bold',
    fontSize: 18,
  },
  conversationSection: {
      marginBottom: theme.spacing(11),

      [theme.breakpoints.up('sm')]: {
        marginBottom: 0,
      }
  },
  downloadProgressLoaderOverlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    overflow: 'hidden',
  },
  DownloadProgressLoader: {
    marginBottom: theme.spacing(),
  },
})

class SingleJob extends Component {
  state = {
    expanded: '',
    log: false,
    conversation: false,
    changedForms: [],
    alertDialog: false,
    reportDialog: false,
    downloadPicturesDialog: false,
    sectionToDownload: '',
    downloading: false,
  }

  async componentDidMount() {
    const { user } = this.props;
    let jobId;
    if (this.props.match.path.indexOf('notification') !== -1) {
      const notificationNumber = this.props.match.params.id;
      jobId = await this.props.actions.getJobByNotificationNumber(notificationNumber);
    } else {
      jobId = this.props.match.params.id;
      this.props.actions.getJob(jobId);
    }
    
    userHasPermission(user, permissions.VIEW_CONVERSATION) && this.props.actions.getNumberOfUnreadComments(jobId);
  }

  componentDidUpdate(prevProps, prevState) {
    // If reportLevel or testAssessment is changed, close all changed & open sections
    if (this.props.job.reportLevel !== prevProps.job.reportLevel
        || this.props.job.testAssessment !== prevProps.job.testAssessment
    ) {
          this.setState({changedForms: [], expanded: ''})
    }
  }

  componentWillUnmount() {
    this.props.actions.clearJob();
  }

  closeDialog = dialog => this.setState({[dialog]: false})

  openReportDialog = () => this.setState({reportDialog: true})

  openDownloadDialog = () => this.setState({downloadPicturesDialog: true})

  openAlertDialog = sectionsObject => !this.state.alertDialog && this.setState({alertDialog: sectionsObject})

  // This is used to determine should an alert be displayed when trying to
  // navigate off the page with unsaved answers in any form(s)
  updateChangedSections = (formName, action) => {
    switch (action) {
      case 'add':
        return this.setState(prevState => ({ changedForms: [...prevState.changedForms, formName] }));
      case 'remove':
        return this.setState(prevState => ({ changedForms: prevState.changedForms.filter(changedForm => changedForm !== formName)}));
      default:
        return;
    }
  }

  updateChangedForms = forms => {
    this.setState({ changedForms: forms })
  }

  renderSections = (sections, job) =>
    sections.map(({ name, formName, isLocked }) => {
      const { classes: c, t, job, user } = this.props;
      const isDisabled = isLocked && isLocked(job);

      return (
        <section key={name}>
          <ExpansionPanel className={c.expansionPanel} classes={{ expanded: c.expansionPanelExpanded }} disabled={isDisabled} expanded={this.state.expanded === name}>
            <ExpansionPanelSummary
              style={{ cursor: 'default' }}
              expandIcon={
                isDisabled
                ? <BlockIcon />
                : <ExpandMoreIcon />}
              IconButtonProps={{ onClick: () => this.state.expanded === name ? this.closeSection(name) : this.openSection(name)}}
              classes={{ expanded: c.title }}
            >
              {t[name]}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={c.expansionPanelDetails}>
              { this.state.expanded === name &&
                <JobSection
                  job={job}
                  user={user}
                  formName={formName}
                  name={name}
                  updateChangedSections={this.updateChangedSections}
                  formTranslations={t}
                  updateChangedForms={this.updateChangedForms}
                />
              }
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </section>
      );
    })

  openSection = sectionToOpen => {
    if (this.state.expanded) {
      return this.closeSection(this.state.expanded, sectionToOpen)
    };

    this.setState({expanded: sectionToOpen})
  }

  closeSection = (sectionToClose, sectionToOpen = null) => {
    const { expanded, alertDialog, changedForms } = this.state;

    // Check if this is a closing action, and if there are unsaved answers in the provided section
    if (!alertDialog && expanded === sectionToClose && changedForms.includes(camelCaseToDash(sectionToClose))) {
      return this.openAlertDialog({sectionToClose, sectionToOpen})
    }

    this.setState({expanded: sectionToOpen || ''});
  }

  toggleSection = section => this.setState(prevState => ({[section]: !prevState[section]}));

  handleAlertDialogConfirm = section => {
    const {sectionToClose, sectionToOpen} = this.state.alertDialog;

    this.closeSection(sectionToClose, sectionToOpen);
    this.updateChangedSections(camelCaseToDash(sectionToClose), 'remove');
    this.closeDialog('alertDialog');
    sessionStorage.removeItem('questionAnswerSession');
  }

  handleDownloadDialogConfirm = async () => {
    this.setState({ downloadPicturesDialog: false, downloading: true });

    this.state.sectionToDownload === 'all'
      ? await this.props.actions.downloadAllPictures(this.props.job.id)
      : await this.props.actions.downloadAllPictures(this.props.job.id, this.state.sectionToDownload)

    this.setState({ downloading: false, sectionToDownload: '' });
  }

  handleRadioSelect = e => this.setState({ sectionToDownload: e.target.value })

  renderAlertDialog = (c, t, gt) =>
    <ConfirmationDialog
      open={!!this.state.alertDialog}
      title={gt.confirmationDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={() => this.closeDialog('alertDialog')}
      handleConfirm={() => this.handleAlertDialogConfirm(this.state.alertDialog)}
    >
      <DialogContentText>{gt.unsavedAnswers}</DialogContentText>
    </ConfirmationDialog>

  renderReportDialog = () =>
    <ReportsDialog
      open={this.state.reportDialog}
      handleCancel={() => this.closeDialog('reportDialog')}
      jobId={this.props.job.id}
    />

  renderDownloadDialog = (t, gt) => {
    const unlockedSections = sections.filter(({isLocked}) => !isLocked(this.props.job));

    return (
      <ConfirmationDialog
        open={this.state.downloadPicturesDialog}
        title={t.downloadPictures}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.confirm}
        confirmDisabled={this.state.downloading}
        handleCancel={() => this.closeDialog('downloadPicturesDialog')}
        handleConfirm={() => this.handleDownloadDialogConfirm()}
      >
        <FormControl>
          <RadioGroup
            aria-label="sections_to_download_pictures"
            name="sections to download pictures"
            onChange={this.handleRadioSelect}
            value={this.state.sectionToDownload || ''}
          >
            <FormControlLabel control={<Radio />} label={t.downloadAllPictures} value='all'/>
            {unlockedSections && unlockedSections.map(section =>
              <FormControlLabel
                key={section.name}
                value={section.formName}
                control={<Radio />}
                label={`${t.downloadPicturesFrom} ${section.name === "receivedProduct" ? gt.Progress['productReceived'] : gt.Progress[section.name]}`}
              />
            )}
          </RadioGroup>
        </FormControl>
      </ConfirmationDialog>
    )
  }

  renderDownloadInProgress = (c, t, gt) => {
    return (
      this.state.downloading &&
        <div className={c.downloadProgressLoaderOverlay}>
          <Loader className={c.DownloadProgressLoader} color='secondary' />
          <Typography variant='caption'>{t.downloadInProgressPleaseWait}</Typography>
        </div>
    );
  }

  render() {
    const { classes: c, t, gt, job, user } = this.props;
    const isReportStatusApproved = job && job.status && job.status.finalReportReleased === 'FULFILLED';

    return (
      <Fragment>
      { job.id
        ? <Fragment>
            <Prompt
              when={this.state.changedForms.length > 0}
              message={gt.unsavedAnswers}
            />
            <SubHeader
              view='singleJob'
              job={{ id: job.jobNumber, createdAt: job.jobDate, modifiedAt: job.jobLastModifiedDate, notificationNumber: job.notificationNumber ,serviceOrderNumber: job.serviceOrderNumber, manual: job.manual }}
              translations={{ title: t.title, createdAt: t.createdAt, modifiedAt: t.modifiedAt, actionButton: gt.report, downloadButton: t.downloadPictures, notificationNumber: t.notificationNumber, serviceOrderNumber: t.serviceOrderNumber, noInfo: gt.noInfo }}
              actionButton={{
                disabled: (!isReportStatusApproved && (userHasRole(user, roles.CUSTOMER) || userHasRole(user, roles.CUSTOMER_CENTER))) || this.state.downloading,
                condition: userHasPermission(user, permissions.GENERATE_AND_DOWNLOAD_REPORT),
                onActionClick: this.openReportDialog,
              }}
              downloadButton={{
                isDisabled: this.state.downloading,
                conditionDownload: job.id && userHasPermission(user, permissions.DOWNLOAD_PICTURES) && isDesktop,
                onActionClickDownload: this.openDownloadDialog,
              }}
            />

            { job.reportLevel > 1 && !job.stcHasTechnicalPossibility &&
              <div className={c.noTechPossibilityContainer}>
                <Typography>{t.noTechPossibilityParagraph1}</Typography>
                <Typography>{t.noTechPossibilityParagraph2}</Typography>
              </div>
            }

            <JobSummary
              job={job}
              t={t}
              user={user}
            />

            {
              userHasPermission(user, permissions.EDIT_JOB) &&
              this.renderSections(sections, job)
            }

            {
              userHasPermission(user, permissions.VIEW_LOG) &&
              <section>
                <ExpansionPanel className={c.expansionPanel} classes={{ expanded: c.expansionPanelExpanded }} expanded={this.state.log}>
                  <ExpansionPanelSummary
                    style={{ cursor: 'default' }}
                    expandIcon={<ExpandMoreIcon />}
                    IconButtonProps={{ onClick: () => this.toggleSection('log')}}
                    classes={{ expanded: c.title }}
                  >
                    {t.log}
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    { this.state.log &&
                      <LogSection
                        jobId={job.id}
                      />
                    }
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </section>
            }

            {
              userHasPermission(user, permissions.VIEW_CONVERSATION) &&
              <section className={c.conversationSection}>
                <ExpansionPanel className={c.expansionPanel} classes={{ expanded: c.expansionPanelExpanded }} expanded={this.state.conversation}>
                  <ExpansionPanelSummary
                    style={{ cursor: 'default' }}
                    expandIcon={<ExpandMoreIcon />}
                    IconButtonProps={{ onClick: () => this.toggleSection('conversation')}}
                    classes={{ expanded: c.title }}
                  >
                    {t.conversation}
                    {this.props.numOfUnreadComments
                      ? <Chip
                          color="secondary"
                          className={c.numOfUnreadComments}
                          label={this.props.numOfUnreadComments}
                          size="small"
                        />
                      : null}
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    { this.state.conversation &&
                      <ConversationSection
                        jobId={job.id}
                      />
                    }
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </section>
            }


          </Fragment>
        : <div className={c.loaderContainer}><Loader color='secondary' /></div>
      }
      { this.renderDownloadInProgress(c, t, gt) }
      { this.renderAlertDialog(c, t, gt) }
      { this.renderDownloadDialog(t, gt) },
      { this.state.reportDialog && this.renderReportDialog() }
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  job: state.singleJob,
  user: state.user,
  numOfUnreadComments: state.comments.numOfUnreadComments,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    getJob: bindActionCreators(getSingleJob, dispatch),
    getJobByNotificationNumber: bindActionCreators(getSingleJobByNotificationNumber, dispatch),
    clearJob: bindActionCreators(clearJob, dispatch),
    getNumberOfUnreadComments: bindActionCreators(getNumberOfUnreadComments, dispatch),
    downloadAllPictures: bindActionCreators(downloadAllPictures, dispatch),
  },
})

export default withStyles(styles)(connect(mapStateToProps,mapDispatchToProps)(withTranslations(SingleJob, 'SingleJob')));



// WEBPACK FOOTER //
// ./src/views/SingleJob/SingleJob.js